import { computed } from 'vue';
import { MinimalOrganisationDto } from '@studyportals/campaign-management-api-interface';
import { LoadingStatuses } from '@/models/loading.interface';
import store from '@/store';

export default class LinkedOrganisationsOverviewCode {

	public isLoading = computed((): boolean => {
		const loadingStatus = store.getters.loadingStatusPrimaryData();
		return loadingStatus === LoadingStatuses.ACTIVE;
	});

	public linkedOrganisations = computed((): MinimalOrganisationDto[] => {
		return store.getters.linkedOrganisations();
	});

	public unlinkOrganisation(organisation: MinimalOrganisationDto): void {
		store.mutations.removeLinkedOrganisation(organisation);
	}
}
